import React, { Dispatch, ReactNode, createContext, useContext, useReducer } from 'react'
import { saveToLocalStorage } from '@/shared/utils/localStorageHelper'

type BranchType = {
    value: string
    label: string
}

type BranchContext = {
    branches: BranchType[]
    currentBranch: BranchType
}

const initialState: BranchContext = {
    branches: [],
    currentBranch: {
        value: '',
        label: ''
    }
}

function branchReducer(state: any, action: any) {
    switch (action.type) {
        case 'set_branches':
            return { ...state, branches: action.branches }
        case 'set_branch':
            saveToLocalStorage<BranchType>('currentBranch', action.currentBranch)
            return { ...state, currentBranch: action.currentBranch }
        default:
            throw new Error('Unknown branch')
    }
}

const BranchDispatchContext = createContext<Dispatch<any>>(() => {})
const BranchContext = createContext<BranchContext>({
    branches: [],
    currentBranch: {
        value: '',
        label: ''
    }
})

export function useBranchContext() {
    return useContext(BranchContext)
}

export function useBranchDispatchContext() {
    return useContext(BranchDispatchContext)
}

export function BranchProvider({ children }: { children: ReactNode }) {
    const [state, dispatch] = useReducer(branchReducer, initialState)
    return (
        <BranchContext.Provider value={state}>
            <BranchDispatchContext.Provider value={dispatch}>
                {children}
            </BranchDispatchContext.Provider>
        </BranchContext.Provider>
    )
}
